module.exports = __webpack_public_path__ + "img/auth-status-init-icon.c53d203c.svg";